/**
 * Centralized Admin Configuration
 * 
 * This is the SINGLE SOURCE OF TRUTH for admin authentication.
 * All admin checks (Firestore rules, Storage rules, frontend guards) should use this config.
 * 
 * IMPORTANT: To add/remove admins, update this file and deploy Firestore/Storage rules.
 */

// Exact admin email allowlist (no regex, no wildcards)
export const ADMIN_EMAILS = [
  'admin@varahasilks.com',
  'support@varahasilks.com',
  'manager@varahasilks.com'
];

/**
 * Check if an email is an admin email
 * @param {string} email - Email to check
 * @returns {boolean} - True if email is in admin list
 */
export const isAdminEmail = (email) => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase().trim());
};

/**
 * Get admin emails for Firestore/Storage rules
 * Returns a string that can be used in security rules
 */
export const getAdminEmailsForRules = () => {
  return ADMIN_EMAILS.map(email => `'${email}'`).join(' ||\n             ');
};

